import { A48SubmissionContextCode } from "./enum/a48-submission-context-code.enum";

export class CplA48SubmissionDetail {
    PPID: string;
    Hours: number;
    UserDate: string;
    Status: string;
    SubmissionID: string;
    CycleStatusID: number;
    StatusID: number;
    ParaStatusID: number;
    SubmissionTimeStamp: Date;
    UserDisplayName: string;
    UserCycleID: string;
    ShouldSubmitToPerms: boolean;
    ContextCode: A48SubmissionContextCode;
}